import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../../components/AdminSidebar";
import { LanguageToggle } from "../../i18n/LanguageContext";
import AcademicSessions from "./masterData/AcademicSessions";
import DegreeTypes from "./masterData/DegreeTypes";
import Faculties from "./masterData/Faculties";
import Subjects from "./masterData/Subjects";
import SubjectCategories from "./masterData/SubjectCategories";
import SubjectBasket from "./masterData/SubjectBasket";
import Degrees from "./masterData/Degrees";
import FeeHeads from "./masterData/FeeHeads";
import FeeRules from "./masterData/FeeRules";
import DocumentTypes from "./masterData/DocumentTypes";
import DocumentRequirements from "./masterData/DocumentRequirements";
import QualificationConfigs from "./masterData/QualificationConfigs";
import CourseSeats from "./masterData/CourseSeats";
import AdmissionProcesses from "./masterData/AdmissionProcesses";
import FormFieldConfig from "./masterData/FormFieldConfig";
import TranslationManagement from "./masterData/TranslationManagement";
import MeritList from "./MeritList";
import AdmissionList from "./AdmissionList";
import RoleManagement from "./RoleManagement";
import AdminUsers from "./AdminUsers";
import AdminDashboard from "./AdminDashboard";

const pages = {
  "academic-sessions": AcademicSessions,
  "degree-types": DegreeTypes,
  faculties: Faculties,
  subjects: Subjects,
  "subject-categories": SubjectCategories,
  "subject-basket": SubjectBasket,
  degrees: Degrees,
  "fee-heads": FeeHeads,
  "fee-rules": FeeRules,
  "document-types": DocumentTypes,
  "document-requirements": DocumentRequirements,
  "qualification-configs": QualificationConfigs,
  "course-seats": CourseSeats,
  "admission-processes": AdmissionProcesses,
  "form-field-config": FormFieldConfig,
  "translations": TranslationManagement,
  "merit-list": MeritList,
  "admission-list": AdmissionList,
  roles: RoleManagement,
  "admin-users": AdminUsers,
};

const AdminLayout = () => {
  const [selected, setSelected] = useState("dashboard");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const admin = JSON.parse(localStorage.getItem("admin") || "{}");

  const handleLogout = () => {
    localStorage.clear();
    navigate("/admin/login");
  };

  const PageComponent = pages[selected];

  return (
    <div className="flex h-screen overflow-hidden">
      <div
        className={`fixed z-20 top-0 left-0 h-full bg-gray-900 text-white w-64 p-4 transition-transform transform md:translate-x-0 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:static md:block`}
      >
        <AdminSidebar
          onSelect={(s) => { setSelected(s); setIsSidebarOpen(false); }}
          handleLogout={handleLogout}
          admin={admin}
          selected={selected}
        />
      </div>

      <div className="flex-1 flex flex-col overflow-y-auto">
        <div className="bg-white border-b px-4 py-2 flex items-center justify-between shadow-sm">
          <button className="md:hidden text-gray-700" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>☰</button>
          <span className="md:hidden text-sm font-semibold text-gray-700">Admin Panel</span>
          <div className="md:ml-auto flex items-center gap-3">
            <LanguageToggle />
            <button
              onClick={handleLogout}
              className="text-xs px-3 py-1 rounded bg-red-50 text-red-600 hover:bg-red-100 border border-red-200"
            >
              Logout
            </button>
          </div>
        </div>

        <main className="p-4">
          {selected === "dashboard" && (
            <AdminDashboard onNavigate={(s) => setSelected(s)} />
          )}
          {PageComponent && <PageComponent />}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
